export default __webpack_public_path__ + "static/media/parmegiana.9cad81e1.jpg";